import { ListProps, UnorderedList } from '@chakra-ui/react';
import React from 'react';

export const CmUnorderedList: React.FC<ListProps> = ({ children, ...rest }) => {
  // @ts-ignore TS2590
  return <UnorderedList {...rest}>{children}</UnorderedList>;
};
